import { useEffect, useState } from "react";

const STORAGE_KEY = "cosanova:visited";

/**
 * True apenas na primeira visita da sessão — usado na animação de entrada da
 * marca no cabeçalho.
 */
export function useFirstVisit(): boolean {
	const [firstVisit, setFirstVisit] = useState(false);

	useEffect(() => {
		let visited: string | null = null;
		try {
			visited = window.sessionStorage.getItem(STORAGE_KEY);
			window.sessionStorage.setItem(STORAGE_KEY, "1");
		} catch {
			// modo privado / storage bloqueado: trata como visita repetida
			return;
		}
		if (!visited) setFirstVisit(true);
	}, []);

	return firstVisit;
}
